export default "__VITE_ASSET__CzLf9jRo__"